module.exports = __webpack_public_path__ + "img/Grappe_6.asset.deae2163.svg";